// Rensselaer Polytechnic Institute's bachelor's majors (#2839). Read on
// 2026-10-01 from the official Rensselaer Catalog 2026-2027 (catalog.rpi.edu):
// the Programs page's "Baccalaureate" and "Baccalaureate - Dual Major" lists,
// with the degree each names (B.S., B.Arch., B.Tech.). Grouped by school as
// the catalog's Degrees Offered table groups them (it calls the Lally School
// "School of Management"). Three programs on the Programs page are not in the
// Degrees Offered table and keep their own group; Electronic Media, Arts, and
// Communication is in the Degrees Offered table but not on the Programs page
// and is left out. Left out: certificates, the Engineering Core Curriculum,
// integrative pathways, minors and graduate programs.
const majors = {
    "slug": "rensselaer-polytechnic-institute-profile",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in the Rensselaer Catalog 2026-2027, grouped by school, with the degree it leads to, plus the dual majors the catalog lists. Minors, pathways, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Architecture",
            "source": {
                "label": "Rensselaer Catalog 2026-2027, Degrees Offered (School of Architecture)",
                "url": "https://catalog.rpi.edu/content.php?catoid=34&navoid=931"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch."
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "Rensselaer Catalog 2026-2027, Degrees Offered (School of Engineering)",
                "url": "https://catalog.rpi.edu/content.php?catoid=34&navoid=931"
            },
            "majors": [
                {
                    "name": "Aeronautical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer and Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Management Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Humanities, Arts, and Social Sciences",
            "source": {
                "label": "Rensselaer Catalog 2026-2027, Degrees Offered (School of Humanities, Arts, and Social Sciences)",
                "url": "https://catalog.rpi.edu/content.php?catoid=34&navoid=931"
            },
            "majors": [
                {
                    "name": "Cognitive Science",
                    "degree": "B.S."
                },
                {
                    "name": "Communication, Media, and Design",
                    "degree": "B.S."
                },
                {
                    "name": "Design, Innovation, and Society",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Electronic Arts",
                    "degree": "B.S."
                },
                {
                    "name": "Games and Simulation Arts and Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.S."
                },
                {
                    "name": "Psychological Science",
                    "degree": "B.S."
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainability Studies",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Lally School of Management",
            "source": {
                "label": "Rensselaer Catalog 2026-2027, Degrees Offered (School of Management)",
                "url": "https://catalog.rpi.edu/content.php?catoid=34&navoid=931"
            },
            "majors": [
                {
                    "name": "Business Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Business and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Finance, Markets, and Emerging Technologies",
                    "degree": "B.S."
                },
                {
                    "name": "Information Technology and Web Science",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing and Advanced Computing",
                    "degree": "B.S."
                },
                {
                    "name": "Production and Operations Management",
                    "degree": "B.Tech."
                }
            ]
        },
        {
            "name": "School of Science",
            "source": {
                "label": "Rensselaer Catalog 2026-2027, Degrees Offered (School of Science)",
                "url": "https://catalog.rpi.edu/content.php?catoid=34&navoid=931"
            },
            "majors": [
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry and Biophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Computational Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Hydrogeology",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Other bachelor's programs",
            "source": {
                "label": "Rensselaer Catalog 2026-2027, Programs",
                "url": "https://catalog.rpi.edu/content.php?catoid=34&navoid=938"
            },
            "note": "These programs are in the catalog's Baccalaureate list but not in its Degrees Offered table by school.",
            "majors": [
                {
                    "name": "Building Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Physician-Scientist",
                    "degree": "B.S.",
                    "note": "With Albany Medical College: the B.S. at RPI and the M.D. at Albany Medical College."
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Dual majors",
            "source": {
                "label": "Rensselaer Catalog 2026-2027, Programs (Baccalaureate - Dual Major)",
                "url": "https://catalog.rpi.edu/content.php?catoid=34&navoid=938"
            },
            "note": "Single bachelor's programs that combine two majors, as the catalog lists them.",
            "majors": [
                {
                    "name": "Aeronautical and Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Aerospace and Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Neuroscience & Psychological Science",
                    "degree": "B.S."
                },
                {
                    "name": "Business & Management and Communications, Media and Design",
                    "degree": "B.S."
                },
                {
                    "name": "Business & Management and Design Innovation and Society",
                    "degree": "B.S."
                },
                {
                    "name": "Business & Management and Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Business & Management and Games and Simulation Arts and Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Business & Management and Information Technology & Web Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Business & Management and Sustainability Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics and Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics and Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics and Industrial & Management Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics and Information Technology & Web Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics and Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Design, Innovation, and Society / Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering and Computer Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Sciences / Sustainability Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical & Nuclear Engineering",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
